;( function( $, window, undefined ) {
  'use strict';

  // global
  var Modernizr = window.Modernizr, $body = $( 'body' );

  $.MenuCollapsible = function( options, element ) {
    this.$el = $( element );
    this._init( options );
  };

  $.MenuCollapsible.defaults= {
    allowMultipleOpen : true
    // classes for the animation effects
    // animationClasses : { classin : 'mc-animate-in', classout : 'mc-animate-out' }
  };

  $.MenuCollapsible.prototype = {
    _init : function( options ) {
      // options
      this.options = $.extend( true, {}, $.MenuCollapsible.defaults, options );
      // cache some elements and initialize some variables
      this._config();

      // var animEndEventNames = {
      //       'WebkitAnimation' : 'webkitAnimationEnd',
      //       'OAnimation' : 'oAnimationEnd',
      //       'msAnimation' : 'MSAnimationEnd',
      //       'animation' : 'animationend'
      //     },
      //     transEndEventNames = {
      //       'WebkitTransition' : 'webkitTransitionEnd',
      //       'MozTransition' : 'transitionend',
      //       'OTransition' : 'oTransitionEnd',
      //       'msTransition' : 'MSTransitionEnd',
      //       'transition' : 'transitionend'
      //     };

      // // animation end event name
      // this.animEndEventName = animEndEventNames[ Modernizr.prefixed( 'animation' ) ] + '.menucollapsible';
      // // transition end event name
      // this.transEndEventName = transEndEventNames[ Modernizr.prefixed( 'transition' ) ] + '.menucollapsible',
      // // support for css animations and css transitions
      // this.supportAnimations = Modernizr.cssanimations,
      // this.supportTransitions = Modernizr.csstransitions;

      this._initEvents();
    },
    _config : function() {
      this.$menu = this.$el.children( 'ul.mc-menu' );
      this.$triggers = this.$menu.children( 'li' ).children( 'a' );
      this.$menuitems = this.$el.find( 'li' );
    },
    _initEvents : function() {
      var self = this;

      this.$triggers.on( 'click.menucollapsible', function( event ) {
        event.stopPropagation();

        var $trigger = $(this);
            // $submenu = $trigger.siblings( 'ul.menu-category-sublist'),
            // $submenus = self.$menu.find('ul.menu-category-sublist');

        if ( self.options.allowMultipleOpen ) {
          $trigger.toggleClass('active');
        } else {
          self.$triggers.removeClass('active');
          $trigger.addClass('active');
        }

        return false;
      } );
    }
  };

  var logError = function( message ) {
    if ( window.console ) {
      window.console.error( message );
    }
  };

  $.fn.menuCollapsible = function( options ) {
    if ( typeof options === 'string' ) {
      var args = Array.prototype.slice.call( arguments, 1 );
      this.each(function() {
        var instance = $.data( this, 'menucollapsible' );
        if ( !instance ) {
          logError( "cannot call methods on menucollapsible prior to initialization; " +
          "attempted to call method '" + options + "'" );
          return;
        }
        if ( !$.isFunction( instance[options] ) || options.charAt(0) === "_" ) {
          logError( "no such method '" + options + "' for menucollapsible instance" );
          return;
        }
        instance[ options ].apply( instance, args );
      });
    } else {
      this.each(function() {
        var instance = $.data( this, 'menucollapsible' );
        if ( instance ) {
          instance._init();
        } else {
          instance = $.data( this, 'menucollapsible', new $.MenuCollapsible( options, this ) );
        }
      });
    }
    return this;
  };

} )( jQuery, window );



// WEBPACK FOOTER //
// ./grails-app/assetsSrc/scripts/modules/menu-collapsible.js